import React, { useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Switch, Button, Row, Col } from 'antd';
import {PlaywrightConfigurationDto} from "../../api";

interface ConfigurationModalProps {
    visible: boolean;
    onCancel: () => void;
    onSave: (values: PlaywrightConfigurationDto) => void;
    loading: boolean;
    initialData?: PlaywrightConfigurationDto | null;
}

const ConfigurationModal: React.FC<ConfigurationModalProps> = ({ visible, onCancel, onSave, loading, initialData }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.setFieldsValue(initialData || {
                configName: '',
                headless: true,
                viewPortWidth: 1920,
                viewPortHeight: 1080,
                locale: 'de-DE',
                active: false,
                proxy: {
                    server: '',
                    username: '',
                    password: '',
                    bypass: '',
                }
            });
        }
    }, [visible, initialData]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            onSave(values);
        } catch (e) {
            // Validation failed
        }
    };

    return (
        <Modal
            open={visible}
            title={initialData ? 'Konfiguration bearbeiten' : 'Neue Konfiguration'}
            onCancel={onCancel}
            onOk={handleOk}
            confirmLoading={loading}
            okText="Speichern"
            cancelText="Abbrechen"
            width={800}
        >
            <Form form={form} layout="vertical">
                <Form.Item name="configName" label="Konfigurationsname" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="headless" label="Headless" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="active" label="Aktiv" valuePropName="checked">
                            <Switch />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="viewPortWidth" label="Viewport Breite" rules={[{ required: true }]}>
                            <InputNumber min={100} max={5000} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="viewPortHeight" label="Viewport Höhe" rules={[{ required: true }]}>
                            <InputNumber min={100} max={5000} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item name="locale" label="Sprache/Locale" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                <h4>Proxy (optional)</h4>
                <Form.Item name={['proxy', 'server']} label="Proxy Server">
                    <Input />
                </Form.Item>
                <Form.Item name={['proxy', 'username']} label="Proxy Benutzername">
                    <Input />
                </Form.Item>
                <Form.Item name={['proxy', 'password']} label="Proxy Passwort">
                    <Input.Password />
                </Form.Item>
                <Form.Item name={['proxy', 'bypass']} label="Proxy Bypass">
                    <Input />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ConfigurationModal;
